function cov_uv0ievpjh() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Footer.tsx";
  var hash = "592aa1d1c339c08990104dadb121b214d9004be0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Footer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 54
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "1": {
        start: {
          line: 29,
          column: 59
        },
        end: {
          line: 29,
          column: 69
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "3": {
        start: {
          line: 83,
          column: 46
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "4": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 87,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 83,
            column: 46
          },
          end: {
            line: 83,
            column: 47
          }
        },
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 87,
            column: 9
          }
        },
        line: 84
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 29
          },
          end: {
            line: 35,
            column: 30
          }
        }, {
          start: {
            line: 35,
            column: 33
          },
          end: {
            line: 35,
            column: 65
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 24
          },
          end: {
            line: 38,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 38
          },
          end: {
            line: 38,
            column: 46
          }
        }, {
          start: {
            line: 38,
            column: 49
          },
          end: {
            line: 38,
            column: 64
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 12
          },
          end: {
            line: 73,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 72,
            column: 80
          }
        }, {
          start: {
            line: 73,
            column: 16
          },
          end: {
            line: 73,
            column: 80
          }
        }],
        line: 71
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "592aa1d1c339c08990104dadb121b214d9004be0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_uv0ievpjh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_uv0ievpjh();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { Box, Flex, Image, Link, Text } from "../../core/index.mjs";
/** @deprecated */
let Footer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Footer, _React$PureComponent);
  function Footer() {
    _classCallCheck(this, Footer);
    return _callSuper(this, Footer, arguments);
  }
  _createClass(Footer, [{
    key: "render",
    value: function render() {
      cov_uv0ievpjh().f[0]++;
      const {
        analyticsName,
        centerAlign,
        minimal,
        color
      } = (cov_uv0ievpjh().s[1]++, this.props);
      cov_uv0ievpjh().s[2]++;
      return jsx(Flex, {
        as: "footer",
        className: "od-footer",
        color: color,
        marginTop: minimal ? (cov_uv0ievpjh().b[0][0]++, 0) : (cov_uv0ievpjh().b[0][1]++, ['10px', '10px', '30px', '30px']),
        padding: ['0 25px', '25px'],
        alignItems: "center",
        justifyContent: centerAlign ? (cov_uv0ievpjh().b[1][0]++, 'center') : (cov_uv0ievpjh().b[1][1]++, 'space-between')
      }, jsx(Box, {
        className: "trademark",
        mr: 3
      }, jsx(Text, {
        fontSize: "s00",
        color: color
      }, jsx(Copyright, {
        fontSize: "s00"
      }), jsx(Link, {
        href: "https://opendoor.com/terms",
        analyticsName: "".concat(analyticsName, "-terms-of-service"),
        "aria-label": "Go to Opendoor terms of service page."
      }, "Terms of Service"), ' · ', jsx(Link, {
        href: "https://opendoor.com/privacy",
        analyticsName: "".concat(analyticsName, "-privacy-policy"),
        "aria-label": "Go to Opendoor privacy policy page."
      }, "Privacy Policy"), ' · ', jsx(Link, {
        href: "https://opendoor.com/privacyrequest",
        analyticsName: "".concat(analyticsName, "-do-not-sell-my-info"),
        "aria-label": "Go to Opendoor privacy request page."
      }, "Do Not Sell My Info"))), "\xA0", jsx(Image, {
        src: color === 'neutrals0' ? (cov_uv0ievpjh().b[2][0]++, 'https://imgdrop.imgix.net/9fa7facf570b48e58d11175dd3c30b6f.svg') : (cov_uv0ievpjh().b[2][1]++, 'https://imgdrop.imgix.net/3c3b55d2bafb409fa42c8b33fd43c9d2.png'),
        alt: "Equal housing opportunity",
        height: 45
      }));
    }
  }]);
  return Footer;
}((React.PureComponent));
_defineProperty(Footer, "defaultProps", (cov_uv0ievpjh().s[0]++, {
  centerAlign: true,
  minimal: false,
  color: 'neutrals90'
}));
export { Footer as default };
cov_uv0ievpjh().s[3]++;
export const Copyright = props => {
  cov_uv0ievpjh().f[1]++;
  cov_uv0ievpjh().s[4]++;
  return jsx(Text, _extends({
    as: "span"
  }, props), "\xA9 ", new Date().getFullYear(), "\xA0\xA0Opendoor\xA0\xA0");
};